import React, { useState, useEffect, useRef } from 'react'
import { Link } from "react-router-dom"
import IcoList from "../../../assets/img/ico-list.svg"
import { Oval } from 'react-loader-spinner'
import { CSSTransition } from 'react-transition-group'
import ModalEmpresaConsul from '../../Modales/Admin/consultora/ModalEmpresaConsul'
import "./AdminConsultora.scss"
import ListaEmpleadosConsul from './ListaEmpleadosConsul';
import ListaAreasConsul from './ListaAreasConsul'
import IllustrationAccess from "../../../assets/img/access.png"

import { useAdmin } from '../../../context/AdminContext'

export const VistaEmpresasContext = React.createContext()

function VistaEmpresasAdmin(props) {

  const { 
    empresas, 
    errorEmpresa, 
    loadingEmpresas, 
    fetchEmpresasById, 
    fetchEmpleadosById 
  } = useAdmin()

  const [expandedRowEmpleados, setExpandedRowEmpleados] = useState(null)
  
  const [modalEmpresa, setModalEmpresa] = useState(false)
  const [objEmpresa, setObjEmpresa] = useState(null)

  const [idEmpresa, setIdEmpresa] = useState(null)

  useEffect(()=>{
    fetchEmpresasById(props.user, props.user.idConsultora)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
  
  const handleEmpleadosById = async (id) => {
    setExpandedRowEmpleados(expandedRowEmpleados === id ? null : id)
    fetchEmpleadosById(props.user, id)
    setIdEmpresa(id)
  }
  
  const handleModalEmpresa = () => {
    setModalEmpresa(true)
  }

  // EDITAR EMPRESA
  const handleModalEditEmpresa = (id) => {
    const obj = empresas.find((e) => e.id_empresa === id)
    setObjEmpresa(JSON.stringify(obj))
    setIdEmpresa(id)
    setModalEmpresa(true)
  }

  const empleadosRef = useRef()

  const user = props.user

  return (
    <VistaEmpresasContext.Provider value={{ user, idEmpresa, setIdEmpresa, objEmpresa, setObjEmpresa }}>
      <ModalEmpresaConsul show={modalEmpresa} onHide={()=>setModalEmpresa(false)} />
      {loadingEmpresas ? (
        <div className='loading__EmpresasAdmin d-flex flex-column align-items-center justify-content-center'>
          <Oval
            visible={true}
            height="80"
            width="80"
            color="#0d6efd"
            ariaLabel="oval-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
          <p className='fw-medium'>Loading...</p>
        </div>
      ) : (
        <>
          {errorEmpresa ? (
            <div className='error__EmpresasAdmin d-flex flex-column align-items-center justify-content-center rounded-3'>
              <img className='img__error mb-4' src={IllustrationAccess} alt="" />
              <h2 className='text-danger fw-semibold mb-2'>Oops!</h2>
              <p className='text-center'>{errorEmpresa}</p>
              <Link className='btn btn-primary rounded-pill shadow-sm fw-medium px-3' to={"/inicio"}>Regresar al home</Link>
            </div>
          ) : (
            <>
              {empresas.length === 0 ? (
                <div className='container__empresas--empty rounded-3 d-flex flex-column align-items-center justify-content-center'>
                  <h2 className='text-blue-500 fw-semibold mb-1 text-center'>No tienes empresas asignadas</h2>
                  <p className='mb-3 text-center'>Para comenzar, agrega una empresa:</p>
                  <button onClick={handleModalEmpresa} className='btn btn-sm btn-primary rounded-pill px-3 fw-medium'>+ Agregar empresa</button>
                </div>
              ) : (
                <div className='container__empresas'>
                  <div className='container__empresas__title d-flex flex-column flex-md-row align-items-start align-items-md-center mb-4'>
                    <h4 className='text-blue-500 m-0 mb-2 mb-md-0 me-md-3'>Empresas</h4>
                    <div className='flex-md-grow-1 d-flex flex-row justify-content-between'>
                      <button onClick={handleModalEmpresa} className='btn btn-sm btn-primary rounded-pill px-3 fw-medium me-3 me-md-0'>+ Agregar empresa</button>
                      <Link className='ms-auto btn btn-sm btn-primary rounded-pill px-3 fw-medium' to={'/admin/empresas/flowchart'}>Ver Flowchart</Link>
                    </div>
                  </div>
                  <div className='container__empresas__main scroll--y scroll--x'>
                    <div className='table__customE'>
                      <div className='table__customE__header'>
                        <div className='table__customE__cell cellE__dropdown'></div>
                        <div className='table__customE__cell cellE__buttons fw-bold text-blue-500'></div>
                        <div className='table__customE__cell cellE__id text-center fw-bold text-blue-500'>#</div>
                        <div className='table__customE__cell cellE__name fw-bold text-blue-500'>Nombre</div>
                        <div className='table__customE__cell cellE__name fw-bold text-blue-500'>Detalles</div>
                        <div className='table__customE__cell cellE__name fw-bold text-blue-500'>Fecha de creación</div>
                        <div className='table__customE__cell cellE__name fw-bold text-blue-500'>Última modificación</div>
                      </div>
                      <div className='table__customE__body'>
                        {empresas.map((e, i) => {
                          return <React.Fragment key={i}>
                              <div className='table__customE__row bgblue'>
                                <div className='table__customE__cell cellE__dropdown'>
                                  <button className='btn__ico btn p-0' onClick={()=>handleEmpleadosById(e.id_empresa)}>
                                    {expandedRowEmpleados === e.id_empresa ? <i className="bi bi-chevron-up"></i> : <i className="bi bi-chevron-down"></i>}
                                  </button>
                                </div>
                                <div className='table__customE__cell cellE__buttons'>
                                  <button onClick={()=>handleModalEditEmpresa(e.id_empresa)} className='btn__ico--g btn border-0 p-0 btn__edit--icon'><i className="bi bi-pencil"></i></button>
                                </div>
                                <div className='table__customE__cell cellE__id fw-bold text-center text-blue-500'>{e.id_empresa}</div>
                                <div className='table__customE__cell cellE__name'>{e.nombre}</div>
                                <div className='table__customE__cell cellE__name'>
                                  {e.banco === 1 && "Banco"}
                                  {e.banco === 0 && "No Banco"}
                                </div>
                                <div className='table__customE__cell cellE__name'></div>
                                <div className='table__customE__cell cellE__name'></div>
                              </div>
                            <CSSTransition
                              in={expandedRowEmpleados === e.id_empresa}
                              timeout={100}
                              classNames="details"
                              unmountOnExit
                              nodeRef={empleadosRef}
                            >
                              <div ref={empleadosRef} className='container__AreaEmpleados d-flex flex-row'>
                                <div className='icon__listaFin d-none d-md-flex justify-content-end'>
                                  <img src={IcoList} alt=''/>
                                </div>
                                <div className='areaEmpleados'>
                                  <div className='container__listas rounded-3'>
                                    <ListaAreasConsul />
                                    <ListaEmpleadosConsul />
                                  </div>
                                </div>
                              </div>
                            </CSSTransition>
                          </React.Fragment>
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </>
      )}
    </VistaEmpresasContext.Provider>
  )
}

export default VistaEmpresasAdmin